import { CollectionProvider } from 'scripts/adapters/stores/lib/collection_store_base';
import createCollectionStoreClass from 'scripts/adapters/stores/lib/create_collection_store_class';
import createConverter from 'scripts/adapters/immutable_converters/lib/create_converter';
import TeamAssistV2Turn from 'models/team_assist_v2_turn';

// Set while a Clear's DELETE hasn't answered: glados still has the session
// being cleared active, so the panel holds new questions until it does.
const CLEARING_PATH = 'clearing';

class TeamAssistV2TurnsProvider extends CollectionProvider {
  isClearing() {
    return !!this.immutableStore.binding.meta(CLEARING_PATH).get();
  }

  static create(immutableStore, options) {
    return new TeamAssistV2TurnsProvider(immutableStore, options);
  }
}

export default class TeamAssistV2TurnsStore extends createCollectionStoreClass({
  converter: createConverter(TeamAssistV2Turn),
}) {
  constructor(binding, opts) {
    super(binding, { createProvider: TeamAssistV2TurnsProvider.create, ...opts });
  }

  isClearing() {
    return this.getProvider().isClearing();
  }

  setClearing() {
    this.binding.meta(CLEARING_PATH).set(true);
  }

  resetClearing() {
    this.binding.meta(CLEARING_PATH).remove();
  }
}
